import { useMemo } from 'react';
import { UNITE_EVENT_PANE } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';
import { UNITE_EVENT_PANE_PERMISSION } from '../constants/permissions';

const useHasAccessToUniteEventPane = () => {
  const hasUniteEventPaneCapabilities = useHasCapability(UNITE_EVENT_PANE);
  const hasUniteEventPanePermission = useHasPermission(
    UNITE_EVENT_PANE_PERMISSION,
  );
  const hasAccessToUniteEventPaneFeature = useMemo(() => {
    return (
      !!hasUniteEventPaneCapabilities?.hasCapability &&
      !!hasUniteEventPanePermission?.hasPermission
    );
  }, [hasUniteEventPaneCapabilities, hasUniteEventPanePermission]);

  return hasAccessToUniteEventPaneFeature;
};

export default useHasAccessToUniteEventPane;
